<div class="cmdk-preview-pane" data-testid="cmdk-preview">
  @if (selected(); as item) {
    @switch (item.kind) {
      @case ('nav') {
        <im-cmdk-preview-command
          [item]="asCommandItem(item)"
          (activated)="activated.emit(item)" />
      }
      @case ('action') {
        <im-cmdk-preview-command
          [item]="asCommandItem(item)"
          (activated)="activated.emit(item)" />
      }
      @case ('ask') {
        <!-- The answer renders where previews render. Arrow to another row and
             you get that row's preview; arrow back and the answer is still
             here, still streaming. -->
        @defer (on immediate) {
          <im-cmdk-ask-pane (continueRequested)="continueInChat.emit()" (closeRequested)="closeAnswer.emit()" (viewSpace)="viewSpace.emit($event)" />
        }
      }
      @case ('app') {
        <im-cmdk-preview-app
          [item]="asAppItem(item)"
          (activated)="activated.emit(item)" />
      }
      @case ('space') {
        <im-cmdk-preview-space
          [item]="asSpaceItem(item)"
          (activated)="activated.emit(item)" />
      }
      @case ('person') {
        <im-cmdk-preview-person
          [item]="asPersonItem(item)"
          (activated)="activated.emit(item)"
          (call)="callPerson.emit(asPersonItem(item))" />
      }
      @case ('news') {
        <im-cmdk-preview-news
          [item]="asNewsItem(item)"
          (activated)="activated.emit(item)" />
      }
      @default {
        <im-cmdk-preview-empty />
      }
    }
  } @else {
    <im-cmdk-preview-empty />
  }
</div>
